module.exports = __webpack_public_path__ + "static/media/montotox.a2d4db2e.png";